import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { ShowcaseUpdate } from '../../services';

export const fetchShowcaseUpdate = createAsyncThunk(
    'showcaseUpdate/fetchShowcaseUpdate',
    async ({ id, file, slug, title, description, content, sort, productId, isAbout, specialField1, isNews, filesToKeep }) => {
        const response = await ShowcaseUpdate(id, file, slug, title, description, content, sort, productId, isAbout, specialField1, isNews, filesToKeep)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const showcaseUpdateSlice = createSlice({
    name: 'showcaseUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseUpdateSlice.reducer;
